<div class="ad-menu" adStickyFill [disable]="disableSticky">
  <ad-section-menu-default [option]="option"></ad-section-menu-default>
  <div *ngIf="customTemplate" class="customTemplate">
    <ng-container *ngTemplateOutlet="customTemplate"></ng-container>
  </div>
</div>
